import React from 'react'
import { Button, FormControl, Grid, TextField } from '@material-ui/core'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Table212 } from './Tables/TableSec2/Table212'
import { Table213 } from './Tables/TableSec2/Table213'
import { useHistory } from 'react-router-dom'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useFormMonitoringAndEvaluation } from '../../../../context/MonitoringAndEvaluationContext'
import { useMonitoreo } from '../../../../context/MonitoreoContext'
import ROUTES from '../../../../routers/routes'

export const MonitoreoSeccion2 = (props) => {
  const { goToStep } = props
  const { monitoringAndEvaluationForm } = useFormMonitoringAndEvaluation()
  const [, dispatch] = useMonitoreo()
  const history = useHistory()

  const GeneralDataSchema = Yup.object().shape({
    Progress_Impact_Indicator: Yup.string().required(
      'Este campo es obligatorio',
    ),
    Progress_Project_Execution: Yup.string().required(
      'Este campo es obligatorio',
    ),
    Challenges_Actions: Yup.string().required('Este campo es obligatorio'),
    Actions_Women_inclution: Yup.string().required('Este campo es obligatorio'),
    Social_EMP: Yup.string().required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      Progress_Impact_Indicator:
        monitoringAndEvaluationForm.Progress_Impact_Indicator || '',
      Progress_Project_Execution:
        monitoringAndEvaluationForm.Progress_Project_Execution || '',
      Challenges_Actions: monitoringAndEvaluationForm.Challenges_Actions || '',
      Actions_Women_inclution:
        monitoringAndEvaluationForm.Actions_Women_inclution || '',
      Social_EMP: monitoringAndEvaluationForm.Social_EMP || '',
      Indicator_Description:
        monitoringAndEvaluationForm?.Indicator_Description || '',
      IdReportAnswer: monitoringAndEvaluationForm.IdReportAnswer,
    },
    validationSchema: GeneralDataSchema,
  })

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 1 })
    goToStep(1)
  }

  return (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => {
              history.push(ROUTES.IFIFORMSSENT.pathname)
            }}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
      </Grid>

      <form id="transfers-form">
        <div style={{ marginBottom: '48px' }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '16px' }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                }}
              >
                <label className="formTitle">
                  Información sobre el avance de la implementación de la medida
                  de adaptación
                </label>
              </div>
              <label className="formDescription">
                Esta sección proporciona información general sobre la asistencia
                técnica solicitada
              </label>
            </Grid>
          </Grid>
        </div>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              2.1. Avance de la implementación de la medida de adaptación
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} style={{ marginBottom: '2%' }}>
              <Grid item xs={12} sm={12} md={12} className="input__container">
                <label className="responsiveLabel">
                  2.1.1 Indicador de adaptación
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="IdCurrencyUser"
                    name="IdCurrencyUser"
                    style={{ width: '100%' }}
                    variant="outlined"
                    disabled
                    value={monitoringAndEvaluationForm.Indicator_Description}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  2.1.2 Avance alcanzado en el indicador de impacto seleccionado
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Por favor, proporcione información sobre el avance
                      alcanzado en el indicador de impacto seleccionado
                    </label>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className="input__container"
                  >
                    <label className="responsiveLabel">
                      1. Informe narrativo del avance alcanzado (Máximo 250
                      palabras)
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <textarea
                        placeholder="Informe narrativo"
                        customInput={TextField}
                        value={formik.values.Progress_Impact_Indicator}
                        disabled
                      ></textarea>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Adjunte documentos de respaldo: (Imágenes, facturas u
                      otros que considere importante)
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Table212
                      IdReportAnswer={
                        monitoringAndEvaluationForm.IdReportAnswer
                      }
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  2.1.3 Avance alcanzado en la ejecución del subproyecto
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Por favor, proporcione información sobre el avance
                      alcanzado en la ejecución del subproyecto
                    </label>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className="input__container"
                  >
                    <label className="responsiveLabel">
                      1. Informe narrativo del avance alcanzado (Máximo 250
                      palabras)
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <textarea
                        placeholder="Informe narrativo"
                        customInput={TextField}
                        value={formik.values.Progress_Project_Execution}
                        disabled
                      ></textarea>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Adjunte documentos de respaldo: (Imágenes, facturas u
                      otros que considere importante)
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Table213
                      IdReportAnswer={
                        monitoringAndEvaluationForm.IdReportAnswer
                      }
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className="input__container"
              style={{ paddingTop: '2%' }}
            >
              <label className="responsiveLabel">
                2.1.4 Desafíos encontrados y acciones emprendidas para resolver
                (Máximo 250 palabras)
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <textarea
                  placeholder="Desafios encontrados"
                  customInput={TextField}
                  value={formik.values.Challenges_Actions}
                  disabled
                ></textarea>
              </FormControl>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              2.2. Avances en la implementación de acciones orientadas a la
              inclusión de la mujer y en el Plan de Gestión Ambiental y Social
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} className="input__container">
                <label className="responsiveLabel">
                  2.2.1 Acciones Orientadas a la inclusión de la mujer
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Proporcione información sobre las acciones revelantes
                  realizadas para incluir a la mujer en la MIPYME para el
                  período de reporte (Máximo 250 palabras)
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Accciones orientadas la inclusión de la mujer"
                    customInput={TextField}
                    value={formik.values.Actions_Women_inclution}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} className="input__container">
                <label className="responsiveLabel">
                  2.2.2 Plan de Gestión Ambiental y Social
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Describa las medidas de mitigación (si las hubiese) aplicadas
                  hasta el momento (Máximo 250 palabras)
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Plan de Gestión Ambiental y Social"
                    customInput={TextField}
                    value={formik.values.Social_EMP}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={1} className="button__container">
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'left' }}
            className="continerButtonNav"
          >
            <Button
              onClick={() => previous()}
              variant="contained"
              className="button__wizard button__previous"
            >
              Anterior
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
